import React from "react";
import { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import BusinessIcon from "@mui/icons-material/Business";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../auth/ProvideAuth";
import useStyles from "./style";
import { Box, Link } from "@material-ui/core";
import MenuCardUser from "./MenuCardUser";
import MenuCardSettings from "./MenuCardSettings";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MobileMenu from "./MobileMenu";

import UsuarioService from "../../services/usuarioService";

const MenuPortal = (props) => {
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const auth = useAuth();
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

    const usuarioPerfil = UsuarioService.getPerfil();

    const menuItens = [
        {
            texto: "Dashboard",
            link: "/",
            ativo: location.pathname == "/",
        },
        {
            texto: matches ? "Relatórios de crédito" : "Relatórios",
            link: "/relatorios",
            ativo: location.pathname == "/relatorios",
        },
        {
            texto: "Histórico",
            link: "/historico",
            ativo: location.pathname == "/historico",
        },
        // {
        //     texto: "Dados Internos",
        //     link: "/dadosInternos",
        //     ativo: location.pathname == "/dadosInternos",
        // }
        //TODO: Implementar regra para definir clientes prepagos e pospagos
        // {
        //   texto: matches ? "Plano contratado" : "Plano",
        //   link: "/plano",
        //   ativo: location.pathname == "/plano",
        // },
    ];

    if (auth.user == null) {
        return false;
    }

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const logout = async (event) => {
        handleMenuClose();
        auth.signout(() => {
            history.push("/login");
        });
    };

    const menuId = "primary-search-account-menu";
    const mobileMenuId = "primary-search-account-menu-mobile";

    const menuSettingsId = "primary-search-settings-menu";

    const ItemMenu = (texto, link, ativo) => {
        const classesBox = ativo
            ? `${classes.menuPrincipalItem} ${classes.menuPrincipalItemAtivo}`
            : classes.menuPrincipalItem;
        return (
            <Typography
                key={link}
                className={classes.menuItem}
                variant="subtitle1"
                noWrap
            >
                <Link
                    component={RouterLink}
                    to={link}
                    variant="inherit"
                    underline="none"
                >
                    <Box className={classesBox}>{texto}</Box>
                </Link>
                <Box
                    height="0.2rem"
                    bgcolor={ativo ? "#FFF" : null}
                    borderRadius="10px"
                    className={classes.menuPrincipalItemBar}
                />
            </Typography>
        );
    };

    return (
        <div className={classes.grow + " noPrint"}>
            <AppBar position="static">
                <Toolbar>
                    <Typography className={classes.title} variant="h6" noWrap>
                        Portal Neocredit
                    </Typography>
                    {menuItens.map((item) =>
                        ItemMenu(item.texto, item.link, item.ativo)
                    )}
                    {usuarioPerfil == 1
                        ? ItemMenu(
                              "Empresas",
                              "/empresas",
                              location.pathname == "/empresas"
                          )
                        : null}
                    <div className={classes.grow} />
                    <div className={classes.sectionDesktop}>
                        {/* <IconButton aria-label="show 17 new notifications" color="inherit">
              <Badge badgeContent={4} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton aria-label="show 4 new mails" color="inherit">
              <SettingsIcon />
            </IconButton> */}
                        {usuarioPerfil == 1 ? (
                            <IconButton
                                edge="end"
                                id="button-settings"
                                aria-label="settings of current user"
                                aria-controls={menuSettingsId}
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                color="inherit"
                                style={{ marginRight: "10px" }}
                            >
                                <BusinessIcon />
                            </IconButton>
                        ) : null}
                        <IconButton
                            edge="end"
                            id="button-account"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                    </div>
                    <div className={classes.sectionMobile}>
                        <IconButton
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <MoreIcon />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            <MobileMenu
                mobileMoreAnchorEl={mobileMoreAnchorEl}
                mobileMenuId={mobileMenuId}
                isMobileMenuOpen={isMobileMenuOpen}
                handleMobileMenuClose={handleMobileMenuClose}
                handleProfileMenuOpen={handleProfileMenuOpen}
            />
            <MenuCardUser
                menuId={menuId}
                anchorEl={anchorEl}
                isMenuOpen={isMenuOpen && anchorEl.id === "button-account"}
                handleMenuClose={handleMenuClose}
                logout={logout}
            />
            <MenuCardSettings
                menuId={menuId}
                anchorEl={anchorEl}
                isMenuOpen={isMenuOpen && anchorEl.id === "button-settings"}
                handleMenuClose={handleMenuClose}
            />
        </div>
    );
};

export default MenuPortal;
